import * as React from 'react';
import { IPermission } from '../../../../data/types';
import { ScrollableArea } from '../../../layout/ScrollableArea';
import { ClearAllButton } from '../../../shared/Button';
import { Count } from '../../../shared/Count';
import { ListControlLabel } from '../../../shared/form/ListControlLabel';
import { ListControlContainer } from '../../../shared/List/ListControlContainer';
import { AccessListItem } from './AccessListItem';

interface IProps {
  permissions: IPermission[];
  onChange: (perms: IPermission[]) => void;
}
export const PermissionsList = (props: IProps): React.ReactElement => {
  const shape = [1, 0];
  /**
   * @description clear all permissions
   */
  const clearAccess = (): void => {
    props.onChange([]);
  };

  /**
   * @description removes a permission
   * @param id
   */
  const removePermissionHandler = (id: string): void => {
    const newPerms = props.permissions?.filter((perm: IPermission): boolean => {
      return perm.id !== id;
    });
    props.onChange(newPerms);
  };
  return (
    <React.Fragment>
      <ListControlLabel label='Team Access'>
        <ClearAllButton
          onClick={clearAccess}
          disabled={props.permissions?.length === 0}
        />
        <Count value={props.permissions?.length} />
      </ListControlLabel>
      <ListControlContainer>
        <ScrollableArea
          style={{
            flex: 1,
          }}
        >
          {props?.permissions?.length > 0
            ? props?.permissions?.map(
                (perm: IPermission, index: number): React.ReactElement => {
                  return (
                    <AccessListItem
                      key={index}
                      teamName={perm.teamName}
                      role={perm.role}
                      id={perm.id}
                      shape={shape}
                      onRemove={removePermissionHandler}
                    />
                  );
                }
              )
            : null}
        </ScrollableArea>
      </ListControlContainer>
    </React.Fragment>
  );
};
